import $ from 'jquery';
export default {
  name: 'pbl_xsj',
  meta: {
    title: '新四军瀑布流'
  },
  data() {
    return {
      list: [],
      singleform: {
        limit: 100,
        page: 1
      },
      showWindow: false,
      modelData: {},
      config: {},
      stageUrl: '',
      screenName: '',
      detailUrl_p: '',
      detailUrl: '',
      detailCode: '',
      windowTop: 0,
      lineTop: 0,
      lineBottom: 0
    };
  },
  methods: {
    hideWindow() {
      this.showWindow = false;
    },
    // 获取文物列表
    getsingleformList() {
      this.singleform.fid = this.$route.query.fid || '203966';
      this.singleform.formId = 313514;
      this.$api.singleformList(this.singleform).then(res => {
        this.setData(res.data);
      });
    },
    setData(data) {
      data = data.map(item => {
        let nItem = {
          name: this.getValInFormData(item.formData, '1'),
          place: this.getValInFormData(item.formData, '2'),
          desc: this.getValInFormData(item.formData, '5'),
          year: this.getValInFormData(item.formData, '3'),
          d_reason: this.getValInFormData(item.formData, '6'),
          sex: this.getValInFormData(item.formData, '8'),
          other_name: this.getValInFormData(item.formData, '7')
        };
        nItem.desc_type = this.getType(nItem.desc);
        nItem.desc_size = this.getSize(nItem.desc);
        return nItem;
      });
      // this.list = this.list.map((item) => {
      //   item.desc_type = this.getType(item.desc)
      //   item.desc_size = this.getSize(item.desc)
      //   return item
      // })
      this.list = data;
      this.$nextTick(() => {
        let list = ['books.js'];
        list.map(item => {
          let oScript = document.createElement('script');
          oScript.type = 'text/javascript';
          oScript.src = `js/${item}`;
          document.body.appendChild(oScript);
        });
        // kaishi()
        let that = this;
        this.getLineDistance();
      });
    },
    getType(data) {
      if (data.split('、').length >= 2) return 'desc_2';
      return '';
    },
    getSize(data) {
      let length = data.length;
      if (length <= 18 && length > 10) return 10 / length * 30;
      if (length > 18) return 10 / (length - 18) * 30 > 18 ? 18 : 10 / (length - 18) * 30;
      return 30;
    },
    getValInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? this.stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    getValInFormDataList(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values;
      if (!target) return '';
      target = target.map(item => {
        return item.val;
      });
      return target.join(',');
    },
    changeWindowTop(data) {
      // this.windowTop = data
    },
    getLineDistance() {
      this.lineTop = this.$refs['videoBoxli_0'][0].offsetHeight / 2 + 39;
      this.lineBottom = this.$refs[`videoBoxli_${this.list.length - 1}`][0].offsetHeight / 2 + 150;
    }
  },
  mounted() {
    this.$nextTick(() => {});
  },
  created() {
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    let list1 = ['FBXLoader.js', 'inflate.min.js', 'TGALoader.js', 'TrackballControls.js', 'PDBLoader.js', 'CSS2DRenderer.js', 'OBJLoader.js', 'FBXLoader.js', 'MTLLoader.js', 'Detector.js'];
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
    list1.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    });
    let list2 = ['jquery-1.11.0.min.js', 'heartcode-canvasloader-min.js', 'threesixty.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/360/${item}`;
      document.body.appendChild(oScript);
    });
    this.getsingleformList();
    let list = ['main.js', 'layer.js'];
    list.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/${item}`;
      document.body.appendChild(oScript);
    });
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  }
};